import React from 'react';
import { ToneMap } from './tone-map/ToneMap';
import { ColorSenseBar } from './color-sense-bar/ColorSenseBar';
import { SameItemPouchList } from './same-item-pouch-list/SameItemPouchList';
import { Divider } from './Divider';
import { GoodsDetail } from './detail/GoodsDetail';

export const Goods = () => {
    return (
        <main>
            <GoodsDetail />
            <Divider />

            <section aria-labelledby="tone-map-heading">
                <h2 id="tone-map-heading" className="sr-only">
                    톤 맵
                </h2>
                <ToneMap />
            </section>
            <Divider />

            <section aria-labelledby="color-sense-bar-heading">
                <h2 id="color-sense-bar-heading" className="sr-only">
                    컬러 센스 바
                </h2>
                <ColorSenseBar />
            </section>
            <Divider />

            <section
                aria-labelledby="same-item-pouch-heading"
                className="w-full h-full flex flex-col items-start justify-center py-5"
            >
                <SameItemPouchList />
            </section>
        </main>
    );
};
